import { render, staticRenderFns } from "./revenue-icon.vue?vue&type=template&id=cf88b432"
import script from "./revenue-icon.vue?vue&type=script&lang=js"
export * from "./revenue-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports